import { AveragePriceSEOBlockContainer } from '@/microfrontends/listing/shared/containers/AveragePriceSEOBlockContainer';
import { HeaderSEOBlockContainer } from '@/microfrontends/listing/shared/containers/HeaderSEOBlockContainer';
import { QuickLinksContainer } from '@/microfrontends/listing/shared/containers/QuickLinksContainer';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';

import { ListingViewModeSwitcherContainer } from '../ListingViewModeSwitcherContainer';

import { SEOBlockLayout } from './components/SEOBlockLayout';

export const SEOBlock = memoWithDisplayName(
  () => (
    <SEOBlockLayout
      averagePrice={<AveragePriceSEOBlockContainer />}
      header={<HeaderSEOBlockContainer />}
      quickLinks={<QuickLinksContainer />}
      viewModeSwitcher={<ListingViewModeSwitcherContainer />}
    />
  ),
  'SEOBlock',
);
